module.exports = __webpack_public_path__ + "static/SQUARE_wake-feb7d7515daf8298064a7f18fb6476e9.jpeg";